import { render, staticRenderFns } from "./Applicant.vue?vue&type=template&id=b10f18c8"
import script from "./Applicant.vue?vue&type=script&lang=js"
export * from "./Applicant.vue?vue&type=script&lang=js"
import style0 from "./Applicant.vue?vue&type=style&index=0&id=b10f18c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports